import { gql } from "@apollo/client";

const GET_JUSTIFICACIONES_VISITA = gql`
query GetJustificaciones($idEvaluacion: Int!, $idProfesional:  Int!) {
    justificacionesVisita(idEvaluacion: $idEvaluacion, idProfesional:  $idProfesional){
        idJustificacionVisita
        idEvaluacion
        idProfesional
        idComboVisitaValorMotivoJustificacion
        fechaVisita
        fechaFinVisita
        fechaAlta
        observacion
    }
}`;

export default GET_JUSTIFICACIONES_VISITA;

export const adapterJustificaciones = (data) => {
  if (!data) return [];
  return data?.justificacionesVisita?.map((j) => ({
    idBase: j.idJustificacionVisita,
    idComboVisitaValorMotivoJustificacion: j.idComboVisitaValorMotivoJustificacion,
    fechaVisita: j.fechaVisita,
    fechaFinVisita: j.fechaFinVisita,
    fechaAlta: j.fechaAlta,
    observacion: j.observacion
  }));
};